import { useQuery } from "@tanstack/react-query";
import { getTripDistance } from "../api/detect";

const useGetTripDistance = ({
  mobility_seq,
  seq,
}: {
  mobility_seq: number;
  seq?: number;
}) => {
  const { data, isLoading } = useQuery({
    queryKey: [
      "TripDistance",
      `mobility_seq-${mobility_seq}`,
      `seq-${seq}`,
    ],
    queryFn: () => getTripDistance({ mobility_seq, seq }),
    enabled: true,
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 0,
  });
  return { data, isLoading };
};
export default useGetTripDistance;
